import React, {Suspense} from "react";
// import Notify from "../components/Toast";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppWrapper from "./components/AppWrapper";
import Navbar from "./components/Navbar";
import useConnectWallet from "./hooks/useConnectWallet";
import Footer from "./pages/Home/Footer";
import Home from "./pages/Home/Home";


 function App() {
  // useConnectWallet();

 
  // useEffect(()=>{
  //   ReactGA.pageview(window.location.pathname + window.location.search)
  // })
  return (
    <Suspense fallback={null}>
      <AppWrapper>
        <Router>
        <Navbar />
        <Routes>
            <Route element={<Home />} path="/" />
        </Routes>
            
          <Footer />
          {/* <Notify /> */}
          {/* <TransactionStateModal /> */}
        </Router>
      </AppWrapper>
    </Suspense>
  );
}

export default App